import { useState } from 'react';

import EditIcon from '@/components/common/OptionButton/icons/Edit/EditIcon';
import OptionButton from '@/components/common/OptionButton/OptionButton';
import BulkUpdateClCustomersModal from './components/BulkUpdateClCustomersModal';
import { useSelectedLines } 
  from '@/pages/ContractDetails/ContractLines/components/ContractLinesGrid/linesSelectionObservable';
import { useSelectedVariableLines } 
  from '@/pages/ContractDetails/ContractLines/components/ContractLinesGrid/variableLinesSelectionObservable';
import {
  ContractLineBillingCycleOutput,
  ContractStatusEnum,
  VariableContractLineOutput,
} from '@/graphql/contracts/_generated_/contracts';

export default function BulkUpdateContractLineCustomers() {
  const [isOpenUpdateClCustomersModal, setIsOpenUpdateClCustomersModal] =
    useState(false);
  const selectedLineRows = useSelectedLines();
  const selectedVariableLineRows = useSelectedVariableLines();

  const handleOnClick = () => {
    setIsOpenUpdateClCustomersModal(true);
  };

  const getContractLineStatus = (
    contractLine: ContractLineBillingCycleOutput | VariableContractLineOutput
  ) => {
    return ((contractLine as ContractLineBillingCycleOutput)?.status ||
      (contractLine as VariableContractLineOutput)?.status) as
      | ContractStatusEnum
      | undefined;
  };

  const editableStatuses = [
    ContractStatusEnum.AwaitingApproval,
    ContractStatusEnum.Active,
    ContractStatusEnum.ActiveDNR,
  ];

  if (
    !selectedLineRows.filter((x) =>
      editableStatuses.includes(
        getContractLineStatus(x.payload.contractLine) ??
          ContractStatusEnum.Cancelled
      )
    ).length &&
    !selectedVariableLineRows.filter((x) =>
      editableStatuses.includes(
        getContractLineStatus(x.payload.contractLine) ??
          ContractStatusEnum.Cancelled
      )
    ).length
  ) {
    return null;
  }

  return (
    <>
      {isOpenUpdateClCustomersModal && (
        <BulkUpdateClCustomersModal
          onClose={() => setIsOpenUpdateClCustomersModal(false)}
        />
      )}

      <OptionButton onClick={handleOnClick} Icon={<EditIcon />}>
        Update Ship To / Invoice To Accounts
      </OptionButton>
    </>
  );
}
